import React from "react";

const moment = require('moment-timezone');

function getTimeString(first_render) {
    let time_render = [];
    let current_time = new Date();
    let nTotalDiff = current_time - first_render;

    let diff_days = Math.floor(nTotalDiff / 1000 / 60 / 60 / 24);
    nTotalDiff -= diff_days * 1000 * 60 * 60 * 24;

    let diff_hours = Math.floor(nTotalDiff / 1000 / 60 / 60);
    nTotalDiff -= diff_hours * 1000 * 60 * 60;

    let diff_minutes = Math.floor(nTotalDiff / 1000 / 60);
    nTotalDiff -= diff_minutes * 1000 * 60;

    if(diff_days > 0 && diff_hours > 0) {
      time_render.push(
        <div className="stats">
          <i className="fa fa-calendar-o" />
          เมื่อ {diff_days} วัน {diff_hours} ชม. ที่แล้ว
        </div>
      )
    } else if (diff_days > 0 && diff_hours < 1) {
      time_render.push(
        <div className="stats">
          <i className="fa fa-clock-o" />
          เมื่อ {diff_days} วันที่แล้ว
        </div>
      )
    } else if (diff_hours > 0 && diff_minutes > 0) {
      time_render.push(
        <div className="stats">
          <i className="fa fa-clock-o" />
          เมื่อ {diff_hours} ชม. {diff_minutes} นาที ที่แล้ว
        </div>
      )
    } else if (diff_hours > 0 && diff_minutes < 1) {
      time_render.push(
        <div className="stats">
          <i className="fa fa-clock-o" />
          เมื่อ {diff_hours} ชม. ที่แล้ว
        </div>
      )
    } else if (diff_minutes > 0) {
      time_render.push(
        <div className="stats">
          <i className="fa fa-clock-o" />
          เมื่อ {diff_minutes} นาที ที่แล้ว
        </div>
      )
    } else {
      time_render.push(
        <div className="stats">
          <i className="fa fa-refresh" />
          ปัจจุบัน
        </div>
      )
    }
    return time_render;
}

function getMonthName(month) {
    let result;
  
    switch(month){
      case 1: result = "Jan";
        break;
      case 2: result = "Feb";
        break;
      case 3: result = "Mar";
        break;
      case 4: result = "Apr";
        break;
      case 5: result = "May";
        break;
      case 6: result = "Jun";
        break;
      case 7: result = "Jul";
        break;
      case 8: result = "Aug";
        break;
      case 9: result = "Sep";
        break;
      case 10: result = "Oct";
        break;
      case 11: result = "Nov";
        break;
      case 12: result = "Dec";
        break;
    }
    return result;
}

function getMonthNameThai(month) {
  let result;

  switch(month){
    case 1: result = "ม.ค.";
      break;
    case 2: result = "ก.พ.";
      break;
    case 3: result = "มี.ค.";
      break;
    case 4: result = "เม.ย.";
      break;
    case 5: result = "พ.ค.";
      break;
    case 6: result = "มิ.ย.";
      break;
    case 7: result = "ก.ค.";
      break;
    case 8: result = "ส.ค.";
      break;
    case 9: result = "ก.ย.";
      break;
    case 10: result = "ต.ค.";
      break;
    case 11: result = "พ.ย.";
      break;
    case 12: result = "ธ.ค.";
      break;
  }
  return result;
}

function getNumPad(num) {
  let result;

  if(num < 10) {
    result = "0" + num
  }
  else {
    result = num
  }

  return result;
}

function toTimeZone(time, zone) {
  var format = 'YYYY-MM-DD HH:mm:ss ZZ';
  return moment(time, format).tz(zone).format(format);
}

function getBranchProvId(active_userinfo, select_role, branch_pro_id) {
  let result_branchprovid;

  if(parseInt(active_userinfo.role_id) === 4) {
      result_branchprovid = active_userinfo.branch_pro_id;
  } else {
      if(parseInt(select_role) === 2 || parseInt(select_role) === 4) {
          result_branchprovid = branch_pro_id
      } else {
          result_branchprovid = null;
      }
  }

  return result_branchprovid;
}

function getBranchId(active_userinfo, select_role, branch_id) {
  let result_branchid;
  
  if(parseInt(select_role) === 2) {
    if(!checkInputNull(branch_id)) {
      // is null
      result_branchid = branch_id;
    } else {
      result_branchid = null;
    }
  } else {
    result_branchid = null;
  }

  return result_branchid;
}

function checkInputNull(input) {
  if(input !== undefined && input !== null && input !== '') { 
    return false;
  } else {
    return true;
  }
}

export { 
  getTimeString, 
  getMonthName, 
  getMonthNameThai, 
  toTimeZone, 
  getNumPad,
  getBranchProvId,
  getBranchId
};